import * as yup from 'yup';
import { API as selectCourier } from '../../api';

export const ShippingIncomingConf = {
  schema: {
    tracking_number: yup.string().nullable(),
    sender: yup.string().nullable(),
    details: yup.string().nullable(),
    is_parcel_for_you: yup.boolean().nullable(),
    storage: yup.string().nullable(),
    id_courier: yup.object().when('tracking_number', {
      is: (tracking_number) =>
        tracking_number === null || tracking_number === '',
      then: yup.object().nullable(),
      otherwise: yup
        .object()
        .nullable()
        .required('Courier is required when Tracking Number is provided'),
    }),
    documents: yup.mixed().nullable(),
  },
  defaultValues: {
    tracking_number: '',
    sender: '',
    details: '',
    is_parcel_for_you: false,
    storage: '',
    id_courier: {},
    id_shipping_status: null,
  },
  fields: [
    {
      id: 'id_courier',
      name: 'id_courier',
      type: 'async_autocomplete',
      label: 'Courier',
      api: selectCourier.couriers,
      required: false,
      xs: 12,
      md: 6,
    },

    {
      id: 'tracking_number',
      name: 'tracking_number',
      type: 'text',
      label: 'Tracking Number',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'sender',
      name: 'sender',
      type: 'text',
      label: 'Sender',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'storage',
      name: 'storage',
      type: 'text',
      label: 'Storage',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'details',
      name: 'details',
      type: 'text',
      label: 'Details',
      required: false,
      xs: 12,
    },
    {
      id: 'is_parcel_for_you',
      name: 'is_parcel_for_you',
      label: 'Parcel For You',
      type: 'switch',
      required: false,
      xs: 12,
    },
  ],
};
